<template>
    <div class="contact-form-section section-space--ptb_120" id="contact">
        <div class="container">
            <div class="row">
                <div class="col-lg-7 order-2 order-lg-1">
                    <div class="section-title text-left section-space--mb_60">
                        <h2 class="font-weight--bold mb-15 wow move-up">Let’s connect!</h2>
                        <span class="section-text_left wow move-up">Let’s leverage software to increase your revenue.</span>
                    </div>
                    <div class="contact-from-wrapper wow move-up">
                      <form action="#" @submit.prevent="addContact">
                            <div class="contact-page-form">
                                <div class="contact-input">
                                    <div class="contact-inner">
                                        <input name="name" type="text" placeholder="Name *" v-model.trim="name" :rules="nameRules">
                                    </div>
                                    <div class="contact-inner">
                                        <input name="email" type="email" placeholder="Email *" v-model.trim="email" :rules="emailRules">
                                    </div>
                                </div>
                                <div class="contact-inner">
                                    <input name="subject" type="text" placeholder="Subject *" v-model.trim="subject">
                                </div>
                                <div class="contact-inner contact-message">
                                    <textarea name="message" placeholder="Message *" v-model.trim="message" ></textarea>
                                </div>
                                <div class="contact-submit-btn">
                                    <button class="ht-btn ht-btn-md" :click="addContact">Send message</button>
                                    <p class="form-message"></p>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="col-lg-5 order-1 order-lg-2">
                    <div class="peatures_image-wrap section-space--mb_40">
                        <div class="image text-center wow move-up">
                            <img class="img-fluid" src="../assets/img/features/aeroland-contact-form-image-01.png" alt="contact thumb">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SubscriberService from "@/services/SubscriberService";

    export default {
        name: 'ContactForm',
        data: ()=> ({
          emailRules: [
            v => !!v || "Email is required",
            v =>
                /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                "E-mail must be valid"
          ],
          nameRules: [
            v => !!v || "Name is required",
            v => v.length <= 64 || "Name must be less than 64 characters"
          ],
          name: "",
          email: "",
          subject: "",
          message: ""
        }),
        mounted() {},
      methods: {
          addContact: function() {
            let contact = {};
            contact.email = this.email
            contact.firstname = this.name
                .split(" ")
                .slice(0, -1)
                .join(" ");
            contact.last_name = this.name
                .split(" ")
                .slice(-1)
                .join(" ");



            contact.subject = this.subject
            contact.message = this.message


            SubscriberService.createSubscriber(contact);
            this.submitted = true;
            this.email = "";
            this.name = "";
            this.message = "";
            this.subject = "";

          }
      }
    }
</script>
